//#region imports
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { TarifModel, TarifCheckboxModel } from '../../model/tarif.model';
import { Pricing, TheftModel, TarifCheckboxStatus } from '../../model/guarantee.model';
import { DecimalPipe } from '@angular/common';
import { SummaryService } from 'src/app/services/summary.service';
import { P5xService } from 'src/app/services/p5x.service';
import { SectionService } from 'src/app/services/section.service';
import { CharacteristicService } from 'src/app/services/characteristic.service';
//#endregion

@Component({
  selector: 'app-guarantee-question4',
  templateUrl: './guarantee-question4.component.html',
  styleUrls: ['./guarantee-question4.component.css']
})
export class GuaranteeQuestion4Component implements OnInit {
  //#region variables
  premiumTotalAmount;
  premiumTotalAmountStr: string;
  flight;
  flightStr: string;
  flightChecked: boolean;
  flightSubChecked: boolean;
  initialPricingData: Pricing;
  updatedPricingData: Pricing;
  tarificationData: TarifModel;
  tarifCheckboxStatus: TarifCheckboxStatus;
  tarificationCheckboxStatusData: TarifCheckboxModel;
  showPremiumtag: boolean = false;
  showtheftprem: boolean = false;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private notification: NotificationService,
    private translate: TranslateService, private globals: Globals, private decimalPipe: DecimalPipe,
    private p5xService: P5xService, private sectionService: SectionService, private characteristicService: CharacteristicService) {
    this.guaranteeService.setshowNormalTitle(false);
  }

  ngOnInit() {
    this.globals.guaranteeHeader2 = true;
    this.sectionService.setCurrentPage('P3-4');
    this.globals.trackPageActivity += ';' + 'P3-4';
    this.initialPricingData = this.guaranteeService.getInitialPricingData();
    this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    this.tarifCheckboxStatus = this.guaranteeService.getTarifCheckboxStatus();
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.flightChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked;
      this.flightSubChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
      this.premiumTotalAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.premiumTotalAmount = +(this.premiumTotalAmountStr.replace(',', '.'));
      this.flightStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft;
      if(this.flightChecked && this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft === '0,00'){
        this.guaranteeService.setPremiumTotalAmount("0");
      }
      else{
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);}
      
    } else {
      this.flightChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked;
      this.flightSubChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
      this.premiumTotalAmountStr = this.initialPricingData.Tarification.Premium_Total_Amount;
      this.premiumTotalAmount = +(this.premiumTotalAmountStr.replace(',', '.'));
      this.flightStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft;
      if(this.flightChecked && this.initialPricingData.Tarification.Premium_Amount_VAT_Theft === '0,00'){
        this.guaranteeService.setPremiumTotalAmount("0");
      }
      else{
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }      
    }
    this.flight = +this.flightStr.replace(',', '.');
    this.guaranteeService.getPremiumTotalShow().subscribe((value) => {
      this.showPremiumtag = value;
    });
    this.showPremiumtag = this.globals.isTheftZero;
    if(this.flight === 0 ){
      this.showtheftprem = true;
    }
  }

  onChange($event) {
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    if ($event.target.checked) {
      this.p5xService.setTheftChecked(true);
      if(this.flight === 0)
      { 
        this.globals.isTheftZero = true; 
        this.guaranteeService.setPremiumTotalShow(true);
        const input = {
          title: this.translate.instant('Msg_Warning_Title'), 
          errorMessage: this.translate.instant('Msg_4Facades_TheftZero'),
          disableClose: false};
        this.characteristicService.serverFailError(input);    
        this.premiumTotalAmount = this.premiumTotalAmount + this.flight;
        this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '');
        this.premiumTotalAmountStr = this.premiumTotalAmountStr.replace('.', ',');
        this.guaranteeService.setPremiumTotalAmount("0");
        if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
          this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
          this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
          this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
        } else {
          this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
          this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
          this.guaranteeService.setInitialPricingData(this.initialPricingData);
        }   
      }
      else {
        this.premiumTotalAmount = this.premiumTotalAmount + this.flight;
        this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '');
        this.premiumTotalAmountStr = this.premiumTotalAmountStr.replace('.', ',');
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
        if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
          this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
          this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
          this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
        } else {
          this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
          this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
          this.guaranteeService.setInitialPricingData(this.initialPricingData);
        }
      }
      
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.flightChecked = true;
    } else {
      if (this.flightSubChecked) {
        if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
          this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        } else {
          this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        }
        this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
        this.reset();
        this.flightSubChecked = false;
      }
      if (this.globals.isTheftZero){
        this.globals.isTheftZero = false;
        this.guaranteeService.setPremiumTotalShow(false);
      }
      this.p5xService.setTheftChecked(false);
      this.premiumTotalAmount = this.premiumTotalAmount - this.flight;
      this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '');
      this.premiumTotalAmountStr = this.premiumTotalAmountStr.replace('.', ',');
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = false;
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.flightChecked = false;
    }
  }

  onSubChange($event) {
    if ($event.target.checked) {
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.updateTarifTheftCall();
      this.flightSubChecked = true;
    } else {
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.reset();
      this.flightSubChecked = false;
    }
  }

  updateTarifTheftCall() {
    let capitalContenu;
    this.guaranteeService.getFlightSubject().subscribe((value: TheftModel) => {
      this.flightStr = value.Premium_Amount_VAT_Theft;
      this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft = this.flightStr;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Net = value.Premium_Amount_VAT_Theft_Net;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = value.Premium_Amount_VAT_Theft_Tax;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = value.Premium_Amount_VAT_Theft_Acquisition;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
          value.Premium_Amount_VAT_Theft_Administration;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = this.flightStr;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = value.Premium_Amount_VAT_Theft_Net;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = value.Premium_Amount_VAT_Theft_Tax;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = value.Premium_Amount_VAT_Theft_Acquisition;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
          value.Premium_Amount_VAT_Theft_Administration;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
    });
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      capitalContenu = this.updatedPricingData.Tarification.CapitalContenuEvalue;
    } else {
      capitalContenu = this.initialPricingData.Tarification.CapitalContenuEvalue;
    }
    const request = this.guaranteeService.updateTarifRequest('true', capitalContenu.replace(',', '.'));
    this.guaranteeService.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
      // console.log(response);
      this.guaranteeService.updateTarifTheftCalculation(response);
    });
  }

  reset() {
    let currentFlightValue;
    let premiumTotalAmountStr;
    let theftObj: TheftModel;
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      if (this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft) {
        const premiumAmountVatTheft = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        theftObj = {
          Premium_Amount_VAT_Theft: premiumAmountVatTheft,
          Premium_Amount_VAT_Theft_Net: premiumAmountVatTheftNet,
          Premium_Amount_VAT_Theft_Tax: premiumAmountVatTheftTax,
          Premium_Amount_VAT_Theft_Acquisition: premiumAmountVatTheftAcquisition,
          Premium_Amount_VAT_Theft_Administration: premiumAmountVatTheftAdministration
        };
        this.flightStr = premiumAmountVatTheft;
        const originalFlightValue = this.convertStringToNumber(premiumAmountVatTheft);
        currentFlightValue = +this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
        premiumTotalAmountStr = this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Total_Amount.toString();
        const premiumTotalAmount = this.convertStringToNumber(premiumTotalAmountStr) -
          (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValue;
        premiumTotalAmountStr = this.convertNumberToString(premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(premiumTotalAmountStr);
        this.updatedPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      }
    } else {
      if (this.guaranteeService.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft) {
        const premiumAmountVatTheft = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Administration;
        theftObj = {
          Premium_Amount_VAT_Theft: premiumAmountVatTheft,
          Premium_Amount_VAT_Theft_Net: premiumAmountVatTheftNet,
          Premium_Amount_VAT_Theft_Tax: premiumAmountVatTheftTax,
          Premium_Amount_VAT_Theft_Acquisition: premiumAmountVatTheftAcquisition,
          Premium_Amount_VAT_Theft_Administration: premiumAmountVatTheftAdministration
        };
        this.flightStr = premiumAmountVatTheft;
        const originalFlightValue = this.convertStringToNumber(premiumAmountVatTheft);
        currentFlightValue = +this.guaranteeService.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
        premiumTotalAmountStr = this.guaranteeService.getInitialPricingData().Tarification.Premium_Total_Amount.toString();
        const premiumTotalAmount = this.convertStringToNumber(premiumTotalAmountStr) -
          (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValue;
        premiumTotalAmountStr = this.convertNumberToString(premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(premiumTotalAmountStr);
        this.initialPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
    }
    this.guaranteeService.setFlightSubject(theftObj);
  }

  convertStringToNumber(value: string): number {
    return +(value.replace(',', '.'));
  }

  convertNumberToString(value: number): string {
    return this.decimalPipe.transform(value, '0.2-2').replace(',', '').replace('.', ',');
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
